import { handleAction, combineActions } from 'redux-actions';

import { getDatasourceStatesAction, disconnectServiceAction } from '../actions/dataSources';
import { defaultErrorHandler, isError } from './errors';

const initialState = {};

const mapToObject = arr => arr.reduce((o, e) => {
  const { service, ...rest } = e;
  o[service] = { ...rest };
  return o;
}, {});

export const dataSourcesReducer = (state, action) => {
  if (action.type === getDatasourceStatesAction.toString()) {
    if (isError(action)) {
      return initialState;
    }
    return mapToObject(action.payload) || initialState;
  }
  return state;
};

export default handleAction(combineActions(
  getDatasourceStatesAction,
  disconnectServiceAction,
), {
  next: dataSourcesReducer,
  throw: defaultErrorHandler,
}, initialState);
